/**
 * تنظیمات مشترک Sentry برای اپ Tools
 * فقط خطاهای دامین‌های مجاز به Sentry ارسال می‌شوند.
 */

// دامین‌هایی که اجازه ارسال خطا به Sentry را دارند
export const SENTRY_ALLOWED_DOMAINS = [
  "tools.bimeh.com",
  "testtools.bimeh.com",
  "localhost:3000",
  "localhost:3002",
];

/**
 * بررسی می‌کند آیا دامین فعلی مجاز ارسال خطا به Sentry است یا نه
 * @param {string} hostname
 * @param {string|null} port
 * @returns {boolean}
 */
export function isDomainAllowed(hostname, port = null) {
  const currentDomain = port ? `${hostname}:${port}` : hostname;

  return SENTRY_ALLOWED_DOMAINS.some((domain) => {
    if (currentDomain === domain) return true;
    if (!port && domain === hostname) return true;
    return false;
  });
}

/**
 * نسخه Release برای Sentry
 * از env یا تاریخ استفاده می‌کند
 */
export function getSentryRelease() {
  if (process.env.SENTRY_RELEASE && process.env.SENTRY_RELEASE.trim()) {
    return process.env.SENTRY_RELEASE.trim();
  }
  return `${new Date().toISOString().slice(0, 10).replace(/-/g, ".")}`;
}
